import { render, staticRenderFns } from "./thePrice.vue?vue&type=template&id=54f7f760&"
import script from "./thePrice.vue?vue&type=script&lang=js&"
export * from "./thePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports